import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-receiving_safety",
  "use": "icon-receiving_safety-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-receiving_safety\"><path d=\"M680.29 505.77l-256 190.37-99.2-119.62a20.68 20.68 0 1 0-31.83 26.4L405 737.63a20.69 20.69 0 0 0 28.23 3.37L705 539a20.68 20.68 0 0 0-24.68-33.18z\" fill=\"#ffffff\" p-id=\"746\" /><path d=\"M904.59 351.66l-55-161.14a118.05 118.05 0 0 0-111.75-80h-473.9a118.07 118.07 0 0 0-111.76 80l-55 161.14a117.75 117.75 0 0 0-6.33 38.13v422.74A118.21 118.21 0 0 0 209 930.61h583.84a118.21 118.21 0 0 0 118.08-118.08V389.79a117.75 117.75 0 0 0-6.33-38.13zM191.32 203.88a76.72 76.72 0 0 1 72.62-52h473.92a76.71 76.71 0 0 1 72.62 52l52.22 153.05H139.1z m601.52 685.38H209a76.82 76.82 0 0 1-76.73-76.73V398.28h737.3v414.25a76.82 76.82 0 0 1-76.73 76.73z\" fill=\"#ffffff\" p-id=\"747\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/receiving_safety.svg
// module id = MIhS
// module chunks = 39